/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import * as React from 'react';
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';

const StyledCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        color: theme.palette.primary.main,
        fontSize: 16,
        fontWeight:'bold',
        maxWidth: 200, 
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
               wordWrap: "break-word", // Break long words
        whiteSpace: "normal",
        maxWidth: 200, 
    },
}));


const StyledTableCell = ({ label ,children,align}) => {


    return (
        <StyledCell align={align? align : 'left'}>{label} {children}</StyledCell>
    )

}

export default StyledTableCell;
